import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { getDayTypes, type DayType } from '../api/calendar'

/**
 * Classify each date in [from, to] as weekday/saturday/sunday/public_holiday.
 *
 * Returns the TanStack Query result so callers can read `data`, `isPending`,
 * `isError`, etc. The query is disabled until both `from` and `to` are
 * non-empty ISO dates.
 *
 * Stale time is 1h because public holidays are slow-moving — the underlying
 * data does not change between page loads in a typical session.
 */
export function useDayTypes(from: string, to: string): UseQueryResult<DayType[]> {
  return useQuery<DayType[]>({
    queryKey: ['day-types', from, to],
    queryFn: () => getDayTypes(from, to),
    enabled: Boolean(from) && Boolean(to),
    staleTime: 60 * 60 * 1000,
  })
}
